import request from "../utils/request";

export async function getDiscountList(payload) {
  return request.get("Discount/GetDiscounts", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.discountDescription ? payload.discountDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      fullDiscount: payload.fullDiscount ? payload.fullDiscount.value : null,
      productId: payload.product ? payload.product.id : null
    }
  });
}

export async function getDiscountListForDealer(payload) {
  return request.get("Discount/GetDiscountsForDealer", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.discountDescription ? payload.discountDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      fullDiscount: payload.fullDiscount ? payload.fullDiscount.value : null,
      productId: payload.product ? payload.product.id : null
    }
  });
}

export async function getExcel(payload) {
  return request.get("Discount/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.discountDescription ? payload.discountDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      fullDiscount: payload.fullDiscount ? payload.fullDiscount.value : null,
      productId: payload.product ? payload.product.id : null
    }
  })
}

export async function getExcelForDealer(payload) {
  return request.get("Discount/GetExcelForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.discountDescription ? payload.discountDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch && payload.branch.id > 0 ? payload.branch.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      fullDiscount: payload.fullDiscount ? payload.fullDiscount.value : null,
      productId: payload.product ? payload.product.id : null
    }
  })
}
